import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from './useSession';

const ProtectedRoute = ({ children }) => {
  const { session, loading } = useSession();

  // Show loading while checking session
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="text-gray-600 font-medium animate-pulse">Loading...</div>
      </div>
    );
  }

  // Only redirect to login if we're sure there's no session and not loading
  if (!loading && !session) {
    return <Navigate to="/login" replace />;
  }

  // If we have a session or still loading, show children
  return session ? children : null;
};

export default ProtectedRoute;